"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _fastEquals = require("fast-equals");
var _LifeInsurance = _interopRequireDefault(require("../blocks/LifeInsurance"));
var _DeathDismemberment = _interopRequireDefault(require("../blocks/DeathDismemberment"));
var _DependentLife = _interopRequireDefault(require("../blocks/DependentLife"));
var _STD = _interopRequireDefault(require("../blocks/STD"));
var _LTD = _interopRequireDefault(require("../blocks/LTD"));
var _CriticalIllness = _interopRequireDefault(require("../blocks/CriticalIllness"));
var _Drugs = _interopRequireDefault(require("../blocks/Drugs"));
var _Healthcare = _interopRequireDefault(require("../blocks/Healthcare"));
var _OutOfCountry = _interopRequireDefault(require("../blocks/OutOfCountry"));
var _EFAP = _interopRequireDefault(require("../blocks/EFAP"));
var _VirtualHealthcare = _interopRequireDefault(require("../blocks/VirtualHealthcare"));
var _FinancialAwareness = _interopRequireDefault(require("../blocks/FinancialAwareness"));
var _Dental = _interopRequireDefault(require("../blocks/Dental"));
var _SpendingAccounts = _interopRequireDefault(require("../blocks/SpendingAccounts"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PlanDesignForm = /*#__PURE__*/function (_Component) {
  function PlanDesignForm() {
    (0, _classCallCheck2["default"])(this, PlanDesignForm);
    return _callSuper(this, PlanDesignForm, arguments);
  }
  (0, _inherits2["default"])(PlanDesignForm, _Component);
  return (0, _createClass2["default"])(PlanDesignForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        selectedDesignID = _this$props.selectedDesignID,
        selectedClassID = _this$props.selectedClassID,
        designs = _this$props.designs,
        errors = _this$props.errors,
        whitelabel = _this$props.whitelabel,
        isMasterSite = _this$props.isMasterSite,
        savePlanDesignBenefitInitData = _this$props.savePlanDesignBenefitInitData,
        savePlanDesignField = _this$props.savePlanDesignField,
        setChangesMadeFlag = _this$props.setChangesMadeFlag,
        revision = _this$props.revision;
      var current = designs[selectedClassID][selectedDesignID];

      // let's delete all the none plan design stuff so we can compare the two plans correctly.
      var currentBase = _objectSpread({}, current);
      var revisionBase = _objectSpread({}, revision);
      delete currentBase.dateAdded;
      delete currentBase.dateUpdated;
      delete currentBase.pricing;
      delete currentBase.pricingSummary;
      delete revisionBase.effectiveDate;
      delete revisionBase.revisionID;
      delete revisionBase.telusDrugPlanID;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, revision && !(0, _fastEquals.deepEqual)(currentBase.lifeInsurance, revisionBase.lifeInsurance) && /*#__PURE__*/_react["default"].createElement(_LifeInsurance["default"], {
        data: revision.lifeInsurance,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.lifeInsurance : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_LifeInsurance["default"], {
        data: current.lifeInsurance,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.lifeInsurance : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.deathDismemberment, revisionBase.deathDismemberment) && /*#__PURE__*/_react["default"].createElement(_DeathDismemberment["default"], {
        data: revision.deathDismemberment,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.deathDismemberment : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_DeathDismemberment["default"], {
        data: current.deathDismemberment,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.deathDismemberment : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.dependentLife, revisionBase.dependentLife) && /*#__PURE__*/_react["default"].createElement(_DependentLife["default"], {
        data: revision.dependentLife,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.dependentLife : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_DependentLife["default"], {
        data: current.dependentLife,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.dependentLife : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.std, revisionBase.std) && /*#__PURE__*/_react["default"].createElement(_STD["default"], {
        data: revision.std,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.std : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_STD["default"], {
        data: current.std,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.std : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.ltd, revisionBase.ltd) && /*#__PURE__*/_react["default"].createElement(_LTD["default"], {
        data: revision.ltd,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.ltd : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_LTD["default"], {
        data: current.ltd,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.ltd : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.criticalIllness, revisionBase.criticalIllness) && /*#__PURE__*/_react["default"].createElement(_CriticalIllness["default"], {
        data: revision.criticalIllness,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.criticalIllness : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_CriticalIllness["default"], {
        data: current.criticalIllness,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.criticalIllness : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.drugs, revisionBase.drugs) && /*#__PURE__*/_react["default"].createElement(_Drugs["default"], {
        data: revision.drugs,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.drugs : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_Drugs["default"], {
        data: current.drugs,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.drugs : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.healthcare, revisionBase.healthcare) && /*#__PURE__*/_react["default"].createElement(_Healthcare["default"], {
        data: revision.healthcare,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.healthcare : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_Healthcare["default"], {
        data: current.healthcare,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.healthcare : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.outOfCountry, revisionBase.outOfCountry) && /*#__PURE__*/_react["default"].createElement(_OutOfCountry["default"], {
        data: revision.outOfCountry,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.outOfCountry : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_OutOfCountry["default"], {
        data: current.outOfCountry,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.outOfCountry : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.efap, revisionBase.efap) && /*#__PURE__*/_react["default"].createElement(_EFAP["default"], {
        data: revision.efap,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.efap : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_EFAP["default"], {
        data: current.efap,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.efap : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.virtualHealthcare, revisionBase.virtualHealthcare) && /*#__PURE__*/_react["default"].createElement(_VirtualHealthcare["default"], {
        data: revision.virtualHealthcare,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.virtualHealthcare : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_VirtualHealthcare["default"], {
        data: current.virtualHealthcare,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.virtualHealthcare : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.financialAwareness, revisionBase.financialAwareness) && /*#__PURE__*/_react["default"].createElement(_FinancialAwareness["default"], {
        data: revision.financialAwareness,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.financialAwareness : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_FinancialAwareness["default"], {
        data: current.financialAwareness,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.financialAwareness : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.dental, revisionBase.dental) && /*#__PURE__*/_react["default"].createElement(_Dental["default"], {
        data: revision.dental,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.dental : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_Dental["default"], {
        data: current.dental,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.dental : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }), revision && !(0, _fastEquals.deepEqual)(currentBase.spendingAccounts, revisionBase.spendingAccounts) && /*#__PURE__*/_react["default"].createElement(_SpendingAccounts["default"], {
        data: revision.spendingAccounts,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.spendingAccounts : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag,
        isRevisionBlock: true
      }), /*#__PURE__*/_react["default"].createElement(_SpendingAccounts["default"], {
        data: current.spendingAccounts,
        revision: revision,
        selectedClassID: selectedClassID,
        selectedDesignID: selectedDesignID,
        errors: errors ? errors.spendingAccounts : {},
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: savePlanDesignBenefitInitData,
        savePlanDesignField: savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: setChangesMadeFlag
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = PlanDesignForm;